__turbopack_context__.v({
  "fourthScreenContainer": "HappinessInMoment-module-scss-module__DUoLCa__fourthScreenContainer",
  "fourthScreenDescription": "HappinessInMoment-module-scss-module__DUoLCa__fourthScreenDescription",
  "fourthScreenImgOne": "HappinessInMoment-module-scss-module__DUoLCa__fourthScreenImgOne",
  "fourthScreenImgTwo": "HappinessInMoment-module-scss-module__DUoLCa__fourthScreenImgTwo",
  "fourthScreenSvg_one": "HappinessInMoment-module-scss-module__DUoLCa__fourthScreenSvg_one",
  "fourthScreenSvg_two": "HappinessInMoment-module-scss-module__DUoLCa__fourthScreenSvg_two",
  "fourthScreenTextBox": "HappinessInMoment-module-scss-module__DUoLCa__fourthScreenTextBox",
  "fourthScreenTitle": "HappinessInMoment-module-scss-module__DUoLCa__fourthScreenTitle",
  "fourthScreenWrapper": "HappinessInMoment-module-scss-module__DUoLCa__fourthScreenWrapper",
});
